// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, CheckIfDataViewLoading } from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";

/**
 * MCMC-1860: We need to stop chain when isAllowCategoriesRequest = false because LoadCategories returns a lot of data and the dom size become very large
 * @param props
 * @constructor
 */
export const CheckIfAllowCategoriesRequest: typeof CheckIfDataViewLoading = props => {
    const isAllowCategoriesRequest =
        (getSession(props.getState())?.properties.allowCategoriesRequest || "").toLowerCase() === "true";

    if (!isAllowCategoriesRequest) {
        return false;
    }
};

addToChainAfter(chain, CheckIfDataViewLoading, CheckIfAllowCategoriesRequest);
